<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <form @submit.prevent="search">
                    <div class="card">
                        <div class="card-header">
                            <i class="fa fa-search"></i> Pesquisar
                        </div>
                        <div class="card-block">
                            <div class="form-group row">
                                <div class="col-md-4 col-xs-12">
                                    <label>Nome</label>
                                    <input
                                        type="text"
                                        maxlength="150"
                                        class="form-control"
                                        v-model="filter.nome"
                                    />
                                </div>
                                <div class="col-md-4 col-xs-12">
                                    <label>Email</label>
                                    <input
                                        type="text"
                                        maxlength="150"
                                        class="form-control"
                                        v-model="filter.email"
                                    />
                                </div>
                                <div class="col-md-4 col-xs-12">
                                    <label>CPF</label>
                                    <masked-input
                                        v-model.trim="filter.cpf"
                                        mask="111.111.111-11"
                                        class="form-control"
                                    ></masked-input>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-4 col-xs-12">
                                    <label>Telefone</label>
                                    <masked-input
                                        v-model.trim="filter.telefone"
                                        mask="(11) 11111-1111"
                                        class="form-control"
                                    />
                                </div>

                                <div class="col-md-4 col-xs-12">
                                    <label>Código Operadora</label>
                                    <input
                                        type="text"
                                        maxlength="20"
                                        class="form-control"
                                        v-model="filter.codigoOperadora"
                                    />
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label>Assinatura</label>
                                    <select2
                                        :options="assinaturaStatus"
                                        v-model="filter.assinatura"
                                        placeholder="Selecione"
                                        :select-option="true"
                                    >
                                        <option value selected>Selecione</option>
                                    </select2>
                                </div>

                                <div class="col-md-4">
                                    <label>Apólice Emitida</label>
                                    <select2
                                        :options="simNao"
                                        v-model="filter.apolice"
                                        placeholder="Selecione"
                                        :select-option="true"
                                    >
                                        <option value selected>Selecione</option>
                                    </select2>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label>Possui Email?</label>
                                    <select2
                                        :options="simNao"
                                        v-model="filter.possuiEmail"
                                        placeholder="Selecione"
                                        :select-option="true"
                                    >
                                        <option value selected>Selecione</option>
                                    </select2>
                                </div>

                                <div class="col-md-4">
                                    <label>Possui CPF?</label>
                                    <select2
                                        :options="simNao"
                                        v-model="filter.possuiCPF"
                                        placeholder="Selecione"
                                        :select-option="true"
                                    >
                                        <option value selected>Selecione</option>
                                    </select2>
                                </div>

                                <div class="col-md-4">
                                    <label>Operadora/Loja</label>
                                    <select2
                                        :options="assinaturaTipo"
                                        v-model="filter.assinaturaTipo"
                                        placeholder="Selecione"
                                        :select-option="true"
                                    >
                                        <option value selected>Selecione</option>
                                    </select2>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-4 col-xs-12">
                                    <label>Data Assinatura</label>
                                    <flat-pickr
                                        v-model="filter.dataAssinatura"
                                        :config="config"
                                        class="form-control"
                                        placeholder="Selecione"
                                        name="date"
                                    ></flat-pickr>
                                </div>

                                <div class="col-md-4 col-xs-12">
                                    <label>Data Cancelamento</label>
                                    <flat-pickr
                                        v-model="filter.dataCancelamento"
                                        :config="config"
                                        class="form-control"
                                        placeholder="Selecione"
                                        name="date"
                                    ></flat-pickr>
                                </div>

                                <div class="col-md-4">
                                    <label>País</label>
                                    <select-api
                                        v-model="filter.assinaturaPais"
                                        :endpoint="'/pais/pesquisa'"
                                        :opt-text="'nome'"
                                        :select-option="true"
                                    ></select-api>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label>Integradora</label>
                                    <select2
                                        :options="assinaturaIntegradora"
                                        v-model="filter.assinaturaIntegradora"
                                        placeholder="Selecione"
                                        :select-option="true"
                                    >
                                        <option value selected>Selecione</option>
                                    </select2>
                                </div>
                            </div>

                            <hr />
                            <div class="form-group row">
                                <div class="col-md-3">
                                    <ul class="toggle-list">
                                        <li>
                                            <label>Ativo</label>
                                            <input-toggle
                                                v-model="filter.ativo"
                                                :value="filter.ativo"
                                            ></input-toggle>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="form-group row">
                                <div class="col-md-6 text-left">
                                    <button type="button" @click="create" class="btn btn-primary">
                                        Novo Cliente
                                        <i class="fa fa-angle-right"></i>
                                    </button>
                                </div>
                                <div class="col-md-6 text-right">
                                    <button
                                        type="button"
                                        @click="clean"
                                        class="btn btn-primary"
                                    >Limpar</button>
                                    <button type="submit" class="btn btn-default">
                                        <i class="fa fa-search"></i> Pesquisar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <dw-table-header :size="size" @finish="updateSize" :pagination="list"></dw-table-header>
                    </div>
                    <div class="card-block" style="overflow-y: auto;">
                        <table class="table table-bordered table-striped table-md">
                            <dw-table-head :headers="headers" :editable="true" @update="sort"></dw-table-head>
                            <tbody>
                                <tr v-for="item in list.rows">
                                    <td :data-label="headers[0].name">{{ item.id }}</td>
                                    <td :data-label="headers[1].name">
                                        {{ (item.nome ? item.nome : 'NC') }}
                                        <span
                                            v-if="item.ativo"
                                            class="badge badge-success"
                                        >Ativo</span>
                                        <span v-else class="badge badge-danger">Inativo</span>
                                    </td>
                                    <td :data-label="headers[2].name">{{ item.telefone }}</td>
                                    <td :data-label="headers[3].name">{{ item.codigoOperadora }}</td>
                                    <td :data-label="headers[4].name">{{ item.cpf }}</td>
                                    <td :data-label="headers[5].name">{{ item.email }}</td>
                                    <td
                                        :data-label="headers[6].name"
                                    >{{ item.criado_em | formatDate('DD/MM/YYYY HH:mm') }}</td>
                                    <td :data-label="headers[7].name">{{ (item.assinatura ? item.assinatura.tipo : '') }}</td>
                                    <td :data-label="headers[8].name">
                                        <span v-if="!item.assinatura" class="badge badge-warning">Sem Assinatura</span>
                                        <span
                                            v-else-if="item.assinatura.status == 'I'"
                                            class="badge badge-success"
                                        >Ativo</span>
                                        <span v-else-if="item.assinatura.status == 'C'" class="badge badge-danger">Cancelado</span>
                                    </td>
                                    <td :data-label="headers[9].name">
                                        <span v-if="item.assinatura">
                                            {{ item.assinatura.dataTransacao | formatDate('DD/MM/YYYY HH:mm') }}
                                        </span>
                                    </td>
                                    <td :data-label="headers[10].name">
                                        <span v-if="item.assinatura">
                                            {{ item.assinatura.dataInicio | formatDate('DD/MM/YYYY HH:mm') }}
                                        </span>
                                    </td>
                                    <td :data-label="headers[11].name">
                                        <span v-if="item.assinatura">
                                            {{ item.assinatura.dataFim | formatDate('DD/MM/YYYY HH:mm') }}
                                        </span>
                                    </td>
                                    <td :data-label="headers[12].name">
                                        <span v-if="item.apolice && item.apolice.length > 0"
                                            class="badge badge-success">Emitida</span>
                                        <span v-else class="badge badge-warning">Sem Apólices</span>
                                    </td>
                                    <td :data-label="headers[13].name">
                                        <span v-if="item.apolice && item.apolice.length > 0">
                                            {{ item.apolice[0].dataInicio | formatDate('DD/MM/YYYY HH:mm') }}
                                        </span>
                                    </td>
                                    <td :data-label="headers[14].name">
                                        <span v-if="item.apolice && item.apolice.length > 0">
                                            {{ item.apolice[0].dataFim | formatDate('DD/MM/YYYY HH:mm') }}
                                        </span>
                                    </td>

                                    <td>
                                        <button
                                            class="btn btn-primary btn-sm"
                                            @click="edit(item.id)"
                                        >
                                            <i class="fa fa-edit"></i>
                                        </button>

                                        <button
                                            class="btn btn-info btn-sm"
                                            v-tooltip="'Apólices'"
                                            @click="apolicy(item.id)"
                                        >
                                            <i class="fas fa-file-contract"></i>
                                        </button>

                                        <router-link
                                            :to="{ name: 'list-pet', params:{idCliente:item.id}}"
                                            class="btn btn-primary btn-sm"
                                        >
                                            <i class="fa fa-paw"></i>
                                        </router-link>
                                        <button
                                            class="btn btn-danger btn-sm"
                                            @click="remove(item.id)"
                                        >
                                            <i class="far fa-trash-alt"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <dw-pagination
                            :pagination="list"
                            :page="page"
                            @update="fetchData"
                            :offset="size"
                        ></dw-pagination>
                    </div>
                </div>
            </div>
            <!--/.col-->
        </div>
        <!--/.row-->
    </div>
</template>

<script>
import {
    isUndefinedOrNullOrEmpty,
    clearCpfCnpj,
    clearPhone
} from "@/services/string";
import Collections from "@/helpers/collections";
import Facade from "../../facade/facade";
import flatPickr from "vue-flatpickr-component";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";
import SelectApi from "../../components/Input/SelectApi";
const facade = new Facade();

export default {
    components: { flatPickr, SelectApi },
    data() {
        return {
            headers: [
                { name: "Cód.", key: "id" },
                { name: "Nome", key: "nome" },
                { name: "Tel.", key: "telefone" },
                { name: "Cód. Op.", key: "codigoOperadora" },
                { name: "CPF", key: "cpf" },
                { name: "E-mail", key: "email" },
                { name: "Data de Criação", key: "criado_em" },
                { name: "Operadora", key: "assinatura", sort: false },
                { name: "Status", key: "assinatura", sort: false },
                { name: "Billing", key: "`assinatura.dataTransacao`" },
                { name: "Inicio", key: "`assinatura.dataInicio`" },
                { name: "Fim", key: "`assinatura.dataFim`" },
                { name: "Apólice", key: "apolice", sort: false },
                { name: "Inicio", key: "`apolice.dataInicio`" },
                { name: "Fim", key: "`apolice.dataFim`" },
            ],
            list: {},
            filter: {
                nome: "",
                email: "",
                cpf: "",
                telefone: "",
                ativo: true,
                assinatura: 'T',
                apolice: 'T',
                dataAssinatura: '',
                dataCancelamento: '',
                possuiEmail: 'T',
                possuiCPF: 'T',
                assinaturaTipo: 'T',
                assinaturaPais: 'T',
                assinaturaIntegradora: 'T',
                codigoOperadora: ''
            },
            size: 20,
            page: 0,
            assinaturaStatus: Collections.assinaturaStatus,
            assinaturaTipo: Collections.assinaturaTipo,
            assinaturaPais: Collections.assinaturaPais,
            assinaturaIntegradora: Collections.assinaturaIntegradora,
            simNao: Collections.simNao,
            order: ["id", "DESC"],
            config: {
                mode: "range",
                wrap: false,
                enableTime: false,
                locale: Portuguese,
                altInput: true,
                altFormat: "d/m/Y",
                allowInput: true
            }
        };
    },
    computed: {
        isAdmin() {
            return facade.isAdmin();
        }
    },
    methods: {
        sort(data) {
            this.order = [data.key, data.direction];
            this.fetchData(this.page);
        },
        clean() {
            this.filter = {
                nome: "",
                email: "",
                cpf: "",
                telefone: "",
                ativo: true,
                assinatura: 'T',
                apolice: 'T',
                dataAssinatura: '',
                dataCancelamento: '',
                codigoOperadora: ''
            };
        },
        create() {
            this.$router.push({ name: "new-client" });
        },
        edit(id) {
            this.$router.push({ name: "edit-client", params: { id: id } });
        },
        apolicy(id) {
            this.$router.push({ name: "list-policies", params: { id: id } });
        },
        remove(id) {
            this.$swal({
                title: "Você tem certeza?",
                text: "Não será possÃ­vel reverter esta operação",
                showCancelButton: true,
                confirmButtonText: "Sim, deletar!",
                cancelButtonText: "Não, cancelar!"
            }).then(
                () => {
                    this.$loading.show(true);

                    let ret = facade.deleteClient(id);
                    ret.then(response => {
                        this.$notify.success(
                            "",
                            "Registro removido com sucesso."
                        );
                        this.fetchData(0);
                        this.$loading.show(false);
                    }).catch(e => {
                        this.$notify.error(
                            "Erro!",
                            "Ocorreu um problema ao deletar o cliente."
                        );
                        this.$loading.show(false);
                    });
                },
                dismiss => {}
            );
        },
        fetchData(page) {
            let vm = this;
            vm.page = page;

            let params = {
                params: { page: page, size: vm.size, order: vm.order }
            };

            let clone = _.cloneDeep(this.filter);
            if (!isUndefinedOrNullOrEmpty(clone.telefone))
                clone.telefone = clearPhone(clone.telefone);
            if (!isUndefinedOrNullOrEmpty(clone.cpf))
                clone.cpf = clearCpfCnpj(clone.cpf);

            for (let key in clone) {
                if (clone.hasOwnProperty(key)) {
                    params["params"][key] = clone[key];
                }
            }

            this.$loading.show(true);
            params.cpf = clearCpfCnpj(params.cpf);
            let ret = facade.listClient(params);
            ret.then(response => {
                vm.list = response.data.data;
                this.$loading.show(false);
            }).catch(e => {
                this.$notify.error(
                    "Erro!",
                    "Ocorreu um problema ao listar os clientes."
                );
                this.$loading.show(false);
            });
        },
        search() {
            this.fetchData(0);
        },
        updateSize(value) {
            let vm = this;
            vm.size = value;
            this.fetchData(0);
        }
    },
    beforeMount() {
        this.fetchData(0);
    }
};
</script>



// WEBPACK FOOTER //
// List.vue?0fd29b1e